/* わんにゃんケア百科 */
(function () {
  'use strict';

  /* ── アンカー付きURLで該当QAを開く ── */
  function openFromHash() {
    var h = window.location.hash;
    if (!h || h.length < 2) return;
    var el;
    try { el = document.getElementById(decodeURIComponent(h.slice(1))); } catch (e) { return; }
    if (el && el.tagName === 'DETAILS') {
      el.open = true;
      el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }
  document.addEventListener('DOMContentLoaded', openFromHash);
  window.addEventListener('hashchange', openFromHash);

  /* ── 目次クリックでも開く ── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS') el.open = true;
  });

  /* ── このQ&Aへのリンクをコピー ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-qa-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-qa-copy');
    var done = function () {
      var prev = btn.textContent;
      btn.textContent = 'コピーしました';
      setTimeout(function () { btn.textContent = prev; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () {});
    }
  });

  /* ══ トップページの横断検索 ══ */
  var idx = document.getElementById('qa-search-index');
  var input = document.getElementById('qa-search-input');
  var out = document.getElementById('qa-search-results');
  if (!idx || !input || !out) return;

  var raw = [];
  try { raw = JSON.parse(idx.textContent); } catch (e) { return; }

  /* 表記のゆれを吸収する正規化
     ・NFKC（全角英数→半角、半角カナ→全角）
     ・カタカナ→ひらがな（目ヤニ と 目やに を同一視）
     ・長音符・中黒・空白を除去 */
  function norm(s) {
    if (!s) return '';
    var t = String(s);
    if (t.normalize) t = t.normalize('NFKC');
    t = t.toLowerCase();
    t = t.replace(/[\u30a1-\u30f6]/g, function (m) {
      return String.fromCharCode(m.charCodeAt(0) - 0x60);
    });
    return t.replace(/[\u30fc\u30fb\s\u3000]/g, '');
  }

  /* 漢字とかなで揺れる語の同義語。入力がいずれかに完全一致したときだけ展開する */
  var SYN = [
    ['歯磨き', '歯みがき', 'はみがき', 'デンタル'],
    ['目やに', '目ヤニ', 'めやに'],
    ['爪切り', '爪きり', 'つめきり'],
    ['爪とぎ', 'つめとぎ'],
    ['犬', 'いぬ', 'わんちゃん', '愛犬'],
    ['猫', 'ねこ', 'にゃんこ', '愛猫'],
    ['うんち', '便', '排便', 'うんこ'],
    ['おしっこ', '尿', '排尿'],
    ['ごはん', 'ご飯', 'フード', '餌', 'えさ', 'エサ'],
    ['動物病院', '病院', '獣医'],
    ['シニア', '高齢', '老犬', '老猫'],
    ['サプリ', 'サプリメント'],
    ['トイレ', '排泄'],
    ['お風呂', 'シャンプー', '入浴'],
    ['熱中症', '暑さ'],
    ['毛玉', 'ヘアボール'],
    ['吐く', '嘔吐', 'げど'],
    ['やせ', '痩せ', '痩せすぎ'],
    ['太る', '肥満', 'ダイエット'],
    ['歯石', '歯垢'],
    ['涙やけ', 'なみだやけ']
  ].map(function (g) { return g.map(norm); });

  /* 検索対象をあらかじめ正規化して保持 */
  var data = raw.map(function (d) {
    return { q: d.q, c: d.c, u: d.u, nq: norm(d.q), nc: norm(d.c), na: norm(d.a || '') };
  });

  function expand(q) {
    var terms = [q];
    SYN.forEach(function (g) {
      if (g.indexOf(q) !== -1) {
        g.forEach(function (w) { if (terms.indexOf(w) === -1) terms.push(w); });
      }
    });
    return terms;
  }

  /* 質問文に一致 → カテゴリ名に一致 → 回答本文に一致 の順で並べる */
  function search(qRaw) {
    var q = norm(qRaw);
    if (!q) return [];
    var terms = expand(q);
    var hits = [];
    data.forEach(function (d) {
      var tier = 9, pos = 9999;
      terms.forEach(function (t) {
        var i = d.nq.indexOf(t);
        if (i !== -1 && (tier > 0 || i < pos)) { tier = 0; pos = Math.min(pos, i); return; }
        if (tier > 1 && d.nc.indexOf(t) !== -1) { tier = 1; pos = 0; return; }
        if (tier > 2 && d.na.indexOf(t) !== -1) { tier = 2; pos = d.na.indexOf(t); }
      });
      if (tier < 9) hits.push({ d: d, tier: tier, pos: pos });
    });
    hits.sort(function (a, b) { return a.tier - b.tier || a.pos - b.pos; });
    return hits;
  }

  var LIMIT = 15;
  function render(qRaw) {
    out.innerHTML = '';
    if (!norm(qRaw)) { out.hidden = true; return; }
    var hits = search(qRaw);

    if (!hits.length) {
      var none = document.createElement('li');
      none.className = 'qa-search__empty';
      none.textContent = '「' + qRaw + '」に該当するギモンは見つかりませんでした';
      out.appendChild(none);
      out.hidden = false;
      return;
    }

    var head = document.createElement('li');
    head.className = 'qa-search__empty';
    head.textContent = hits.length > LIMIT
      ? hits.length + '件中 上位' + LIMIT + '件を表示'
      : hits.length + '件見つかりました';
    out.appendChild(head);

    hits.slice(0, LIMIT).forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = h.d.u;
      a.textContent = h.d.q;
      var s = document.createElement('span');
      s.className = 'qa-search__cat';
      s.textContent = h.tier === 2 ? h.d.c + '（回答の中に一致）' : h.d.c;
      a.appendChild(s);
      li.appendChild(a);
      out.appendChild(li);
    });
    out.hidden = false;
  }

  var t;
  input.addEventListener('input', function () {
    var v = this.value;
    clearTimeout(t);
    t = setTimeout(function () { render(v); }, 100);
  });
  input.addEventListener('focus', function () {
    if (this.value) render(this.value);
  });
})();
